<template>
  <BjDrawerForm ref="BjDrawerForm" :form="form" :rules="rules" label-width="120px" @handleConfirm="handleConfirm">
    <el-col :span="22">
      <el-form-item :label="$t('BusinessLogisticsCompanyPostCode.country')" prop="country">
        <BjInput v-model="form.country" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>

    <el-col :span="22">
      <el-form-item :label="$t('BusinessLogisticsCompanyPostCode.state')" prop="state">
        <BjInput v-model="form.state" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>

    <el-col :span="22">
      <el-form-item :label="$t('BusinessLogisticsCompanyPostCode.suburb')" prop="suburb">
        <BjInput v-model="form.suburb" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>

    <el-col :span="22">
      <el-form-item :label="$t('BusinessLogisticsCompanyPostCode.postcode')" prop="postcode">
        <BjInputNumber v-model="form.postcode" :min="0" not-auto-zero />
      </el-form-item>
    </el-col>

    <el-col :span="22">
      <el-form-item label="Label" prop="label">
        <BjInput v-model="form.label" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>

    <el-col :span="22">
      <el-form-item label="LabelSub" prop="labelsub">
        <BjInput v-model="form.labelsub" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>

    <el-col :span="22">
      <el-form-item label="Zone" prop="zone">
        <BjInput v-model="form.zone" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>

  </BjDrawerForm>
</template>
<script>
import { thirdApi } from '@/api';

const getDefaultForm = () => {
  return {
    country: null,
    state: null,
    postcode: null,
    suburb: null,
    label: null,
    labelsub: null,
    zone: null,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
    };
  },
  computed: {
    rules() {
      // 表单校验
      const rules = {
        country: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        state: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        postcode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        suburb: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      };
      return rules;
    }
  },
  watch: {},
  mounted() {
  },
  methods: {

    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('BusinessLogisticsCompanyPostCode.dataFormTitle_Edit') : this.$t('BusinessLogisticsCompanyPostCode.dataFormTitle_Add'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    addApi(API_DATA) {
      thirdApi.addPostCode(API_DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      thirdApi.updatePostCode(API_DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
